import { PipelineItem, PipelineDraft, SECTION_ORDER } from '../types';
import { normalizeProjectName } from './displayFormat';

type PipelineOrderItem = Pick<PipelineItem, 'section' | 'targetPreview' | 'district' | 'projectName' | 'roadName'> & {
  id?: number;
  itemId?: number | null;
};

export function projectNameOf(item: Pick<PipelineItem, 'projectName' | 'roadName'>): string {
  return normalizeProjectName(item.projectName) || '';
}

export function roadNameOf(item: Pick<PipelineItem, 'projectName' | 'roadName'>): string {
  return item.roadName?.trim() || '';
}

function previewSortKey(raw: string | null): number {
  if (!raw) return Number.POSITIVE_INFINITY;
  const value = raw.trim().toUpperCase();
  const quarter = value.match(/^(?:Q([1-4])|([1-4])Q)\s*[-/]?\s*(\d{4})$/);
  if (quarter) return new Date(Number(quarter[3]), (Number(quarter[1] || quarter[2]) - 1) * 3, 1).getTime();
  const half = value.match(/^([12])H\s*[-/]?\s*(\d{4})$/);
  if (half) return new Date(Number(half[2]), Number(half[1]) === 1 ? 0 : 6, 1).getTime();
  const parsed = Date.parse(raw);
  return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY;
}

function districtSortKey(raw: string | null): number {
  const digits = raw?.match(/\d+/)?.[0];
  return digits ? Number(digits) : Number.POSITIVE_INFINITY;
}

export function comparePipelineItems(a: PipelineOrderItem, b: PipelineOrderItem): number {
  return SECTION_ORDER.indexOf(a.section) - SECTION_ORDER.indexOf(b.section)
    || previewSortKey(a.targetPreview) - previewSortKey(b.targetPreview)
    || districtSortKey(a.district) - districtSortKey(b.district)
    || (projectNameOf(a) || roadNameOf(a)).localeCompare(projectNameOf(b) || roadNameOf(b), undefined, { sensitivity: 'base' })
    || (a.id ?? a.itemId ?? 0) - (b.id ?? b.itemId ?? 0);
}

export function comparePipelineDrafts(a: PipelineDraft, b: PipelineDraft): number {
  return comparePipelineItems({ ...a, id: a.itemId ?? undefined }, { ...b, id: b.itemId ?? undefined });
}

export function normalizePipelineTenure(value: string | null | undefined): string | null {
  const raw = value?.trim() || '';
  if (!raw) return null;
  return /^(?:99|999)\s*years?(?:\s+(?:leasehold|freehold))?$/i.test(raw)
    ? raw.match(/^999/i) ? '999 Years' : '99 Years'
    : raw;
}
